var pleinEcran = {};

pleinEcran.parametresEvenement = {recognizers: [[Hammer.Tap, {threshold: 10}]]};
pleinEcran.evenement = "tap.pleinEcran";
pleinEcran.cibleEvenement = "#content, #scan-view";

pleinEcran.delaiPleinEcranTemporaire = 5 * 1000;
pleinEcran.delaiPleinEcranTemporaireAffichage = 100;
pleinEcran.delaiPleinEcranTemporaireEtat = 400;

pleinEcran.etatnormal = "normal";
pleinEcran.etatpleinecran = "pleinecran";
pleinEcran.etatpleinecrantemporaire = "pleinecrantemporaire";

pleinEcran.listeAttributs = {"normal": {"body": {"data-screenmode": "normal"}, "#header": {"class" : "pleinEcranNormal"}, "footer": {"class" : "pleinEcranNormal"}, "#localisation_content": {"class" : "pleinEcranNormal"}}
		, "pleinecran": {"body": {"data-screenmode": "fullscreen"}, "#header": {"class" : "pleinEcranBarres"}, "footer": {"class" : "pleinEcranBarres"}, "#localisation_content": {"class" : "pleinEcran"}}
		, "pleinecrantemporaire": {"body": {"data-screenmode": "tempdisplay"}, "#header": {"class" : "pleinEcranTemporaire"}, "footer": {"class" : "pleinEcranTemporaire"}, "#localisation_content": {"class" : "pleinEcranTemporaire"}}
	};

// Attribut sur le body : data-screenmode = normal | fullscreen | tempdisplay

pleinEcran.init = function () {
	pleinEcran.normalEcran();
};

pleinEcran.initEcran = function () {
	pleinEcran.miseAjourClasses(pleinEcran.etat);
	if ( pleinEcran.etat == pleinEcran.etatpleinecrantemporaire ) {
		pleinEcran.effacerTimeOut();
		pleinEcran.activerTimeOutTemporaire();
	}
	$(pleinEcran.cibleEvenement).off(pleinEcran.evenement);
	switch ( pleinEcran.etat ) {
		case pleinEcran.etatpleinecran :
			$(pleinEcran.cibleEvenement).hammer($.extend({}, pleinEcran.parametresEvenement)).on(pleinEcran.evenement, pleinEcran.pleinEcranTemporaire);
			break;
		case pleinEcran.etatpleinecrantemporaire :
			$(pleinEcran.cibleEvenement).hammer($.extend({}, pleinEcran.parametresEvenement)).on(pleinEcran.evenement, pleinEcran.pleinEcran);
			break;
		case pleinEcran.etatnormal :
		default :
			break;
	}
};

pleinEcran.activerTimeOutTemporaire = function () {
	pleinEcran.timeoutID = window.setTimeout(pleinEcran.pleinEcran, pleinEcran.delaiPleinEcranTemporaire);
};

pleinEcran.effacerTimeOut = function () {
	if ( pleinEcran.timeoutID ) {
		window.clearTimeout(pleinEcran.timeoutID);
		pleinEcran.timeoutID = null;
	}
};

pleinEcran.$getElementScroll = function () {
	var $scrollElement = $(".localisation_wrap");
	if ( $scrollElement.length == 0 ) {
		$scrollElement = $(".contentScrollable");
	}
	if ( $scrollElement.length > 0 ) {
		return $scrollElement;
	}
}

pleinEcran.sauvegarderScroll = function () {
	var $elementScroll = pleinEcran.$getElementScroll();
	if ( $elementScroll ) {
		pleinEcran.scrollSauvegarde = pleinEcran.$getElementScroll().scrollTop();
	}
}

pleinEcran.restaurerScroll = function () {
	var $elementScroll = pleinEcran.$getElementScroll();
	if ( $elementScroll ) {
		if ( pleinEcran.scrollSauvegarde !== null ) {
			var hauteurElement = $elementScroll.height();
			var hauteurScrollElement = $elementScroll[0].scrollHeight;
			$elementScroll.scrollTop(Math.min(pleinEcran.scrollSauvegarde, Math.max(0, hauteurScrollElement - hauteurElement)));
		} else {
			$elementScroll.scrollTop(0);
		}
	}
	pleinEcran.scrollSauvegarde = null;
}

pleinEcran.miseAjourClasses = function (nouvelEtat) {
	if ( pleinEcran.etat && (nouvelEtat !== pleinEcran.etat) ) {
		var listeAttributsEtat = pleinEcran.listeAttributs[pleinEcran.etat];
		if ( listeAttributsEtat ) {
			for ( var selecteur in listeAttributsEtat ) {
				var listeChangements = listeAttributsEtat[selecteur];
				for ( var nomChangement in listeChangements ) {
					if ( nomChangement === "class" ) {
						$(selecteur).removeClass(listeChangements[nomChangement]);
					} else {
						$(selecteur).removeAttr(nomChangement);
					}
				}
			};
		}
	}
	var listeAttributsNouvelEtat = pleinEcran.listeAttributs[nouvelEtat];
	if ( listeAttributsNouvelEtat ) {
		for ( var selecteur in listeAttributsNouvelEtat ) {
			var listeChangements = listeAttributsNouvelEtat[selecteur];
			for ( var nomChangement in listeChangements ) {
				if ( nomChangement === "class" ) {
					$(selecteur).addClass(listeChangements[nomChangement]);
				} else {
					$(selecteur).attr(nomChangement, listeChangements[nomChangement]);
				}
			}
		};
	}
};

pleinEcran.toggleMode = function () {
	if ( pleinEcran.etat !== pleinEcran.etatpleinecran ) {
		tagManagerController.tagGoogleAnalyticsAction({"eventCategory": "Header", "eventAction": "Full Screen", "eventLabel": "Full Screen"});

		drawerNavigation.closeListVehicleHeader();
		drawerNavigation.closePanelMenu();

		pleinEcran.effacerTimeOut();
		if ( pleinEcran.etat === pleinEcran.etatnormal ) {
			pleinEcran.sauvegarderScroll();
			pleinEcran.pleinEcran();
			pleinEcran.restaurerScroll();
		} else {
			pleinEcran.sauvegarderScroll();
			pleinEcran.normalEcran();
			pleinEcran.restaurerScroll();
		}
	}
};

pleinEcran.normalEcran = function () {
	pleinEcran.effacerTimeOut();
	pleinEcran.miseAjourClasses(pleinEcran.etatnormal);
	pleinEcran.etat = pleinEcran.etatnormal;
	$(pleinEcran.cibleEvenement).off(pleinEcran.evenement);
	pleinEcran.messagePleinEcranChange();
};

pleinEcran.pleinEcran = function () {
	pleinEcran.effacerTimeOut();
	pleinEcran.miseAjourClasses(pleinEcran.etatpleinecran);
	pleinEcran.etat = pleinEcran.etatpleinecran;
	$(pleinEcran.cibleEvenement).off(pleinEcran.evenement);
	$(pleinEcran.cibleEvenement).hammer($.extend({}, pleinEcran.parametresEvenement)).on(pleinEcran.evenement, pleinEcran.pleinEcranTemporaire);
	pleinEcran.messagePleinEcranChange();
	drawerNavigation.closeListVehicleHeader();
	drawerNavigation.closePanelMenu();
};

pleinEcran.pleinEcranTemporaire = function () {
	pleinEcran.effacerTimeOut();
	if ( pleinEcran.timeoutIDpleinEcranTemporaire ) {
		window.clearTimeout(pleinEcran.timeoutIDpleinEcranTemporaire);
		pleinEcran.timeoutIDpleinEcranTemporaire = null;
	}
	pleinEcran.timeoutIDpleinEcranTemporaire = window.setTimeout(pleinEcran.pleinEcranTemporaireAffichage, pleinEcran.delaiPleinEcranTemporaireAffichage);
};

pleinEcran.pleinEcranTemporaireAffichage = function () {
	pleinEcran.miseAjourClasses(pleinEcran.etatpleinecrantemporaire);
	window.setTimeout(function () { pleinEcran.etat = pleinEcran.etatpleinecrantemporaire; }, pleinEcran.delaiPleinEcranTemporaireEtat);
	$(pleinEcran.cibleEvenement).off(pleinEcran.evenement);
	$(pleinEcran.cibleEvenement).hammer($.extend({}, pleinEcran.parametresEvenement)).on(pleinEcran.evenement, pleinEcran.pleinEcran);
	pleinEcran.effacerTimeOut();
	pleinEcran.activerTimeOutTemporaire();
	pleinEcran.messagePleinEcranChange();
};

pleinEcran._transitionEventName = false;

pleinEcran.messagePleinEcranChange = function () {
	function whichTransitionEvent() {
		if ( ! pleinEcran._transitionEventName ) {
			var t;
			var el = document.createElement('fakeelement');
			var transitions = {
				'transition':'transitionend',
				'OTransition':'oTransitionEnd',
				'MozTransition':'transitionend',
				'WebkitTransition':'webkitTransitionEnd'
			}

			for ( t in transitions ) {
				if ( el.style[t] !== undefined ) {
					pleinEcran._transitionEventName = transitions[t];
					break;
				}
			}
		}
		return pleinEcran._transitionEventName;
	}

	$("#header").one(whichTransitionEvent(),
		function(event) {
			window.postMessage({event: "pleinecranchange.pap"}, "*");
		}
	);
}
